import Effluent from '@/models/Effluent'
import User, { hasRole, Role } from '@/models/User'

export default class EffluentPolicy {
	viewAny(_user: User) {
		return false
	}

	view(user: User, effluent: Effluent) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === effluent.entry.catalog.company.id
			case Role.AUDITOR:
				return user.auditor?.id === effluent.entry.catalog.auditor?.id
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, effluent: Effluent) {
		return hasRole(user, Role.USER) && user.company?.id === effluent.entry.catalog.company.id
	}

	restore(user: User, effluent: Effluent) {
		return hasRole(user, Role.USER) && user.company?.id === effluent.entry.catalog.company.id
	}

	delete(user: User, effluent: Effluent) {
		return hasRole(user, Role.USER) && user.company?.id === effluent.entry.catalog.company.id
	}

	forceDelete(_user: User, _effluent: Effluent) {
		return false
	}
}
